import axios from "axios";
import store from "../store/index";
import { logout } from "../store/slices/AuthSlice";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:5000";

if (!process.env.REACT_APP_API_URL) {
  console.warn(
    "REACT_APP_API_BASE_URL is not defined in .env file. Using default: " +
      baseURL
  );
}

const instance = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor - add token to headers if exists
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors globally
instance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      store.dispatch(logout());
      return Promise.reject(error);
    } else if (status === 500) {
      alert("Server error occurred. The page will reload.");
      setTimeout(() => window.location.reload(), 2000);
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

// Exported API helper functions

export const fetchDataFromApi = (url, config = {}) => {
  return instance.get(url, config);
};

export const postData = (url, data, config = {}) => {
  return instance.post(url, data, config);
};

export const editData = (url, data, config = {}) => {
  return instance.put(url, data, config);
};

export const deleteData = (url, config = {}) => {
  return instance.delete(url, config);
};

export const uploadImage = (url, formData, config = {}) => {
  return instance.post(url, formData, {
    ...config,
    headers: {
      ...config.headers,
      "Content-Type": "multipart/form-data",
    },
  });
};
